import React, {} from 'react'
import styles from './copy.module.scss'
import { message } from "antd"
import { useIntl } from 'react-intl'

interface Iprops {
  title: any,
  icon?: boolean,
  noTitle?: boolean
}

const Copy: React.FC<Iprops> = (props) => {
  const intl = useIntl()
  const { icon = false, title, noTitle = false } = props
  const copy = (e: any) => {
    e.stopPropagation()
    let oDiv = document.createElement('textarea')
    oDiv.value = title
    oDiv.innerHTML = title
    document.body.appendChild(oDiv)
    oDiv.select()
    document.execCommand("Copy")
    document.body.removeChild(oDiv)
    message.success(intl.formatMessage({id: '复制成功！'}))
  }
  return (
    <span style={{cursor: 'pointer'}} onClick={(e) => copy(e)}>{noTitle ? '' : title} {icon ? <i className="iconfont icon-copy" style={{fontSize: 12}} /> : null}</span>
  )
}

export default Copy

